
module.exports = function (app) {
  app.channel.on('render:acct:completion', async (user, tagIds) => {
    const AccountCompletion = (await import(/* webpackChunkName: "account-completion" */ '@feature/account-completion-overlay/src/account-completion-overlay')).default;
    const acoComponent = new AccountCompletion({ user, tagIds }); // eslint-disable-line no-unused-vars
    app.channel.trigger('display:modal:acct-compl-overlay');
  });
};
